/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "expand-2694961a--sprite",
  "use": "expand-2694961a--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"expand-2694961a--sprite\"><rect width=\"36\" height=\"36\" fill=\"#fff\" opacity=\"0\" /><g transform=\"translate(-887.09 -1033.371)\"><path d=\"M898.1,1041.39a2.946,2.946,0,0,0-3,2.891v8.109h2v-8a1,1,0,0,1,1-1h8v-2Zm15,9v8a1,1,0,0,1-1,1h-8v2h8a3.009,3.009,0,0,0,3-3v-8Z\" fill=\"currentColor\" /><path d=\"M915.09,1041.373v4.92a.5.5,0,0,1-1,0v-3.21l-6.26,6.26a.508.508,0,0,1-.36.15.5.5,0,0,1-.35-.85l6.27-6.27h-3.22a.5.5,0,0,1-.5-.5.508.508,0,0,1,.5-.5Z\" fill=\"currentColor\" /><path d=\"M903.06,1054.113l-6.27,6.27h3.22a.5.5,0,0,1,.5.5.508.508,0,0,1-.5.5h-4.92v-4.92a.5.5,0,0,1,1,0v3.22l6.27-6.27a.5.5,0,1,1,.7.7Z\" fill=\"currentColor\" /></g></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
